// src/pages/SpotSitePage.jsx
import React from 'react';
import styled from 'styled-components';
import { useSearchParams } from 'react-router-dom';
import { branches } from '../constant/spotsiteData';
import SubPage from '../template/SubPage';
import MyHelmet from '../hooks/Helmet';

const SpotSitePage = () => {
  const [searchParams] = useSearchParams();
  const selected = searchParams.get('center');
  const selectedBranch =
    branches.find((b) => b.slug === selected) || branches[0];

  // branches 데이터를 menuItems 형태로 변환
  const menuItems = branches.map((branch) => ({
    id: branch.slug,
    label: branch.name,
    path: `/spotsite?center=${branch.slug}`,
  }));

  // 선택된 지점의 콘텐츠 렌더링
  const renderContent = () => {
    if (!selectedBranch) return null;

    return (
      <DetailContainer>
        <DetailSection>
          <SectionTitle>소개</SectionTitle>
          <Description>{selectedBranch.description}</Description>
        </DetailSection>

        <DetailSection>
          <SectionTitle>한줄 요약</SectionTitle>
          <Summary>{selectedBranch.summary}</Summary>
        </DetailSection>

        <DetailSection>
          <SectionTitle>공식 사이트</SectionTitle>
          {selectedBranch.url ? (
            <SiteLink
              href={selectedBranch.url}
              target="_blank"
              rel="noopener noreferrer"
            >
              {selectedBranch.name} 공식 사이트 방문 →
            </SiteLink>
          ) : (
            <DisabledText>공식 사이트 준비 중입니다.</DisabledText>
          )}
        </DetailSection>
      </DetailContainer>
    );
  };

  return (
    <>
      <MyHelmet />
      <SubPage
        title="지점 소개"
        description="지역 기반 자활·돌봄 네트워크를 소개합니다."
        menuItems={menuItems}
        currentNo={selected || branches[0].slug}
        submenuTitle={selectedBranch?.name || ''}
        breadcrumbMenu="지점 소개"
        breadcrumbLink={`/spotsite?center=${branches[0].slug}`}
        contentHeight="auto"
      >
      {renderContent()}
    </SubPage>
    </>
  );
};

export default SpotSitePage;

/* Styled Components */

const DetailContainer = styled.div`
  /* 데스크톱 기본 스타일 */
  display: flex;
  flex-direction: column;
  gap: 32px;

  /* 모바일 스타일 */
  @media (max-width: 767px) {
    padding: 0 5%;
    gap: 24px;
  }
`;

const DetailSection = styled.section`
  /* 데스크톱 기본 스타일 */
  padding: 20px 0;
  border-bottom: 1px solid #f0f0f0;

  &:last-child {
    border-bottom: none;
  }

  /* 모바일 스타일 */
  @media (max-width: 767px) {
    padding: 16px 0;
  }
`;

const SectionTitle = styled.h3`
  /* 데스크톱 기본 스타일 */
  font-size: 18px;
  font-weight: 700;
  color: #333;
  margin: 0 0 16px 0;
  font-family: 'Nanum Gothic Bold';

  /* 모바일 스타일 */
  @media (max-width: 767px) {
    font-size: 16px;
    margin: 0 0 12px 0;
  }
`;

const Description = styled.p`
  /* 데스크톱 기본 스타일 */
  font-size: 15px;
  color: #555;
  line-height: 1.8;
  white-space: pre-line;
  margin: 0;
  font-family: 'Nanum Gothic';

  /* 모바일 스타일 */
  @media (max-width: 767px) {
    font-size: 14px;
    line-height: 1.7;
  }
`;

const Summary = styled.p`
  /* 데스크톱 기본 스타일 */
  font-size: 15px;
  color: #666;
  line-height: 1.7;
  margin: 0;
  padding: 12px;
  background-color: #f8f9fa;
  border-left: 3px solid #e5857c;
  border-radius: 4px;
  font-family: 'Nanum Gothic';

  /* 모바일 스타일 */
  @media (max-width: 767px) {
    font-size: 14px;
    padding: 10px;
    line-height: 1.6;
  }
`;

const SiteLink = styled.a`
  /* 데스크톱 기본 스타일 */
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 15px;
  color: #ffffff;
  background-color: #e5857c;
  padding: 12px 24px;
  border-radius: 8px;
  text-decoration: none;
  font-weight: 600;
  transition: background-color 0.2s;
  font-family: 'Nanum Gothic Bold';

  &:hover {
    background-color: #d67469;
  }

  /* 모바일 스타일 */
  @media (max-width: 767px) {
    font-size: 14px;
    padding: 10px 20px;
    width: 100%;
    justify-content: center;
    box-sizing: border-box;
  }
`;

const DisabledText = styled.p`
  /* 데스크톱 기본 스타일 */
  font-size: 14px;
  color: #999;
  padding: 12px 20px;
  background-color: #f5f5f5;
  border-radius: 8px;
  border: 1px dashed #ddd;
  margin: 0;
  font-family: 'Nanum Gothic';

  /* 모바일 스타일 */
  @media (max-width: 767px) {
    font-size: 13px;
    padding: 10px 16px;
  }
`;
